export class AuthenticationModel {
    // Values that must never be treated as a real accountId. Guarding here (the single
    // persistence choke point) is critical because `localStorage.setItem('accountId', undefined)`
    // stores the literal STRING "undefined" - which is truthy, so it silently defeats every
    // downstream `if (!accountId)` guard, produces `accountId=undefined` API calls, and (being
    // persisted) survives reloads to poison later sub-account switches.
    private static readonly INVALID_ACCOUNT_IDS = ['', 'undefined', 'null'];

    public set accountId(value: string) {
        if (value == null || AuthenticationModel.INVALID_ACCOUNT_IDS.includes(String(value))) {
            window.localStorage.removeItem('accountId');
            return;
        }
        window.localStorage.setItem('accountId', value);
    }

    public get accountId(): string {
        const stored = window.localStorage.getItem('accountId') || '';
        // Defensive: coerce any previously-persisted bad value back to empty so callers can
        // rely on a plain falsy check.
        return AuthenticationModel.INVALID_ACCOUNT_IDS.includes(stored) ? '' : stored;
    }

    public get isLoggedIn(): boolean {
        return !!this.accountId;
    }

    public removeAccountId() {
        window.localStorage.removeItem('accountId');
    }

    public removeAuthData() {
        this.removeAccountId();
    }
}
